import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const Stepper = ({ steps, currentStep, mobileLabel = 'Žingsnis' }) => {
  const total = steps.length;
  const currentTitle = steps[currentStep - 1];

  return (
    <Card className="w-full">
      <CardContent className="p-0">
        {/* Mobile: only current step */}
        <div className="sm:hidden flex items-center gap-3 p-3">
          {currentStep > total ? (
            <StepIcon number="✓" status="done" />
          ) : (
            <StepIcon number={currentStep} status="current" />
          )}
          <div className="flex flex-col leading-tight">
            <span className="text-xs text-gray-500">
              Žingsnis {Math.min(currentStep, total)}/{total}
            </span>
            <span className="text-sm font-semibold text-gray-900">
              {currentStep > total ? steps[total - 1] : currentTitle}
            </span>
          </div>
        </div>
        {/* Desktop: full stepper with arrows */}
        <div className="hidden sm:flex sm:flex-row w-full">
          {steps.map((title, index) => {
            const stepNumber = index + 1;
            let status = 'upcoming';
            if (stepNumber < currentStep) status = 'done';
            else if (stepNumber === currentStep) status = 'current';

            return (
              <Step
                key={`${title}-${index}`}
                title={title}
                number={stepNumber}
                status={status}
                isLast={index === steps.length - 1}
              />
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

const Step = ({ title, number, status, isLast }) => {
  return (
    <div className="relative flex-1 flex items-center px-4 py-3 bg-white">
      <div className="flex items-center space-x-2 z-10 h-full">
        <StepIcon number={number} status={status} />
        <span className="text-gray-500">{title}</span>
      </div>

      {/* Arrow between steps (desktop only via parent) */}
      {!isLast && (
        <svg
          width="14"
          height="100%"
          viewBox="0 0 20 80"
          xmlns="http://www.w3.org/2000/svg"
          className="hidden sm:block h-full absolute right-0 top-0"
          preserveAspectRatio="none"
        >
          <path d="M0 0 L20 40 L0 80 Z" fill="white" />
          <line
            x1="0"
            y1="0"
            x2="20"
            y2="40"
            stroke="#D1D5DB"
            strokeWidth="1"
          />
          <line
            x1="0"
            y1="80"
            x2="20"
            y2="40"
            stroke="#D1D5DB"
            strokeWidth="1"
          />
        </svg>
      )}
    </div>
  );
};

const StepIcon = ({ number, status }) => {
  const base =
    'w-6 h-6 rounded-full flex items-center justify-center font-bold text-sm';

  const statusClasses = {
    done: 'bg-green-600 text-white',
    current: 'bg-[#1F4B81] text-white',
    upcoming: 'bg-white text-gray-500 border-2 border-gray-300',
  };

  return (
    <div className={`${base} ${statusClasses[status]}`}>
      {status === 'done' ? '✓' : number}
    </div>
  );
};

export default Stepper;
